export const Projects = [
  {
    title: "Tournament app",
    featured: true,
    description:
      "Deze applicatie voor school is om ervoor te zorgen dat kinderen/jongeren zich gemakkelijk kunnen registreren voor een online spel. Alsnog kunnen ze een uur en toernooi kiezen van het gekozen spel.",
    image: "../assets/images/tournament.png",
    tags: ["Mysql", "MaterialDesign", "C#"],
    alt: "Tournament-app",
    date: "2021-2022",
    link: "https://github.com/JorisDeRidder42/DMProject_Toernooi",
    id: 1,
  },
  {
    title: "Pokedraw app",
    featured: true,
    description:
      "Een applicatie die een pokemon-database bevat aan de hand van een pokemon api en waar je een willekeurige Pokémon kunt ophalen en tekenen.",
    image: "../assets/images/phone.jpg",
    tags: ["Pokemon api", "Ionic"],
    alt: "Pokemon-drawing app",
    date: "2021-2022",
    link: "https://github.com/JorisDeRidder42/pokedrawing",
    id: 2,
  },
  {
    title: "Sarandonga",
    featured: false,
    description:
      "Dit is een website ontworpen voor een dansgezelschap in Lint. Sarandonga geeft flamenco-lessen aan kinderen, volwassenen en bejaarden, maar ook optredens en workshops.",
    image: "../assets/images/sarandonga.png",
    tags: ["HTML5", "CSS3", "Javascript", "Bootstrap"],
    date: "2019-2020",
    alt: "Sarandonga website",
    link: "http://www.sarandonga.be/",
    id: 3,
  },
];
